import translator from '@/locales';

export default function url(message = translator.t('INVALID_INPUT_VALUE_URL')) {
  return {
    type: 'url',
    message,
    trigger: 'blur',
  };
}
